export enum HomePageEventType {
  NO_OVERDUE_EXPENSES_LEFT = 'NO_OVERDUE_EXPENSES_LEFT',
  UPDATE_METRICS_CHANGE_EVENT = 'UPDATE_METRICS_CHANGE_EVENT',
}

export interface HomePageEvent {
  type: HomePageEventType;
  payload?: any;
}
